import React from 'react';
import styled from 'styled-components';
import { InnerLayout } from '../styles/Layouts';
import { motion } from 'framer-motion';
import questions from '../data/questions';
import Question from './Question';
import SecondaryButton from './SecondaryButton';
import { Link } from 'react-router-dom';

function FAQSections() {
  return (
    <FaqSectionStyled id="faqs">
      <InnerLayout>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: '0.5' }}
        >
          <h3 className="small-heading">
            Frequently <span>asked questions </span>
          </h3>
          <p className="c-para">
            In here we clear the most common questions, everything you need to know is in the bellow boxes, if you have
            questions or probleams just click in the button bellow and we will reply as soon as possible.
          </p>

          <Link to="/#" className="con-button">
            <SecondaryButton name={'Contact Us'} />
          </Link>

          <div className="questions-content">
            {questions.map((q) => {
              return <Question key={q.id} {...q} />;
            })}
          </div>
        </motion.div>
      </InnerLayout>
    </FaqSectionStyled>
  );
}

const FaqSectionStyled = styled.section`
  .c-para {
    width: 60%;
    margin: 0 auto;
    padding: 1rem 0;
    @media screen and (max-width: 1347px) {
      width: 100%;
    }
  }
  .questions-content {
    padding-top: 1rem;
  }
  .con-button {
    padding: 2rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export default FAQSections;
